import { SearchResult as Result } from "src/screens/search/SearchResult";
import { Person } from "src/screens/search/person/Person";

export const Search = {
    Result,
    Person
};
